import React, { useState, useEffect } from "react";
import { useSettings } from "../context/SettingsContext";

const C = {
  green:    "#004D2B",
  greenMid: "#006B3C",
  greenLt:  "#E6F2EC",
  gold:     "#B8933A",
  cream:    "#F9F6F1",
  white:    "#FFFFFF",
  text:     "#1A1A1A",
  sub:      "#6B6B6B",
  border:   "#E2DDD7",
  eco:      "#1565C0",
  ecobg:    "#EBF2FF",
  pre:      "#6A1B9A",
  prebg:    "#F5EDF9",
  vip:      "#92400E",
  vipbg:    "#FEF3C7",
};

const DEFAULT_TARIFS = [
  { from:"Libreville", to:"Lopé",         eco:9000,  pre:14000, vip:null  },
  { from:"Libreville", to:"Booué",         eco:11000, pre:16500, vip:null  },
  { from:"Libreville", to:"Lastoursville", eco:11500, pre:17000, vip:null  },
  { from:"Libreville", to:"Franceville",   eco:12500, pre:18000, vip:28000 },
  { from:"Owendo",     to:"Booué",         eco:8500,  pre:13000, vip:null  },
  { from:"Owendo",     to:"Franceville",   eco:12000, pre:17500, vip:27000 },
  { from:"Ntoum",      to:"Lambaréné",     eco:6000,  pre:9000,  vip:null  },
  { from:"Lambaréné",  to:"Franceville",   eco:8000,  pre:12000, vip:null  },
];

/*const CLASSES = [
  { key:"eco", icon:"🚃", label:"Économique",    color:C.eco, bg:C.ecobd, cardBg:C.ecobd, desc:"Confort standard avec sièges rembourrés, idéal pour les trajets réguliers." },
  { key:"pre", icon:"⭐", label:"1ère Classe",    color:C.pre, bg:C.prebg, cardBg:C.prebg, desc:"Sièges larges, plus d'espace personnel et service amélioré à bord." },
  { key:"vip", icon:"👑", label:"VIP / Couchette",color:C.vip, bg:C.vipbg, cardBg:C.vipbg, desc:"Compartiments et couchettes privés pour les grands voyages de nuit." },
];*/

const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,wght@0,300;0,500;0,700;1,300;1,500&family=DM+Sans:wght@300;400;500;600&display=swap');
  * { box-sizing: border-box; }
  body { margin: 0; font-family: 'DM Sans', sans-serif; background: ${C.cream}; }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes slideDown { from { opacity:0; transform:translateY(-8px); } to { opacity:1; transform:translateY(0); } }
  .nav-link { color: rgba(255,255,255,0.75); font-size: 14px; font-weight: 500; text-decoration: none; padding-bottom: 3px; position: relative; transition: color .2s; }
  .nav-link::after { content:''; position:absolute; bottom:0; left:0; width:0; height:1.5px; background:${C.gold}; transition: width .25s; }
  .nav-link:hover { color: #fff; }
  .nav-link:hover::after { width: 100%; }
  .nav-link.active { color: #fff; }
  .nav-link.active::after { width: 100%; }
  .class-card { transition: transform .2s, box-shadow .2s; }
  .class-card:hover { transform: translateY(-4px); box-shadow: 0 14px 44px rgba(0,0,0,0.12) !important; }
  .route-row:hover td { background: ${C.greenLt} !important; }
  .mobile-menu { animation: slideDown .25s ease; }
  .mobile-menu-link { color: rgba(255,255,255,0.85); font-size: 15px; font-weight: 500; text-decoration: none; padding: 10px 0; border-bottom: 1px solid rgba(255,255,255,0.1); display: block; }
`;

const HERO_PATTERN = `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.03'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/svg%3E")`;

function useWindowWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const handler = () => setW(window.innerWidth);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return w;
}

const fmt = (n) => n ? n.toLocaleString("fr-FR") + " FCFA" : "-";

export default function Tarifs() {
  const [menuOpen, setMenuOpen] = useState(false);
  const w = useWindowWidth();
  const isMobile = w < 768;
  const isSmall  = w < 480;
  const { settings } = useSettings();
  const TARIFS = (settings.tariffs && settings.tariffs.length > 0) ? settings.tariffs : DEFAULT_TARIFS;

  return (
    <>
      <style>{GLOBAL_CSS}</style>

      {/* NAV */}
      <nav style={{
        background: C.green,
        height: 68,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: isMobile ? "0 20px" : "0 40px",
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxShadow: "0 2px 24px rgba(0,0,0,0.28)",
      }}>
        <a href="/" style={{ fontFamily:"'Fraunces',serif", fontWeight:700, fontSize:20, color:"#fff", textDecoration:"none", display:"flex", alignItems:"center", gap:8 }}>
          🚆 SETRAG
        </a>
        {isMobile ? (
          <button onClick={() => setMenuOpen(o => !o)} style={{ background:"none", border:"none", cursor:"pointer", display:"flex", flexDirection:"column", gap:5, padding:4 }}>
            {[0,1,2].map(i => <span key={i} style={{ display:"block", width:24, height:2, background:"#fff", borderRadius:2 }} />)}
          </button>
        ) : (
          <div style={{ display:"flex", gap:28 }}>
            {[["Accueil","/"],["Tarifs","/tarifs"],["Contact","/contact"]].map(([label, path]) => (
              <a key={path} href={path} className={`nav-link${path==="/tarifs"?" active":""}`}>{label}</a>
            ))}
          </div>
        )}
      </nav>

      {/* MOBILE MENU */}
      {isMobile && menuOpen && (
        <div className="mobile-menu" style={{ position:"fixed", top:68, left:0, right:0, background:C.green, padding:"20px 24px 28px", zIndex:99, borderTop:"1px solid rgba(255,255,255,0.1)", display:"flex", flexDirection:"column", gap:4 }}>
          {[["Accueil","/"],["Tarifs","/tarifs"],["Contact","/contact"]].map(([label, path]) => (
            <a key={path} href={path} className="mobile-menu-link">{label}</a>
          ))}
        </div>
      )}

      {/* HERO */}
      <div style={{ background:"linear-gradient(150deg, #002D1A 0%, #004D2B 50%, #006B3C 100%)", padding: isMobile ? "52px 20px 48px" : "72px 40px 64px", textAlign:"center", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", inset:0, backgroundImage:HERO_PATTERN }} />
        <div style={{ position:"relative" }}>
          <span style={{ display:"inline-block", fontSize:11, fontWeight:600, letterSpacing:"2.5px", textTransform:"uppercase", color:C.gold, background:"rgba(184,147,58,0.15)", border:"1px solid rgba(184,147,58,0.3)", borderRadius:20, padding:"5px 14px", marginBottom:16 }}>
            Ligne Transgabonais
          </span>
          <h1 style={{ fontFamily:"'Fraunces',serif", fontWeight:500, fontSize: isSmall ? 32 : isMobile ? 40 : 52, color:"#fff", lineHeight:1.15, margin:"0 0 14px" }}>
            Grille<br/><em style={{ fontStyle:"italic", color:"#A8D5BC" }}>tarifaire</em>
          </h1>
          <p style={{ color:"rgba(255,255,255,0.68)", fontSize:15, fontWeight:300, maxWidth:400, margin:"0 auto" }}>
            Tarifs en Francs CFA (FCFA) pour tous les trajets sur la ligne Transgabonais.
          </p>
        </div>
      </div>

      {/* MAIN */}
      <div style={{ maxWidth:900, margin:"0 auto", padding: isMobile ? "0 16px" : "0 24px" }}>

        {/* Section header */}
        <div style={{ textAlign:"center", padding: isMobile ? "40px 0 28px" : "56px 0 36px", animation:"fadeUp .5s ease both" }}>
          <div style={{ fontSize:11, fontWeight:600, letterSpacing:"2px", textTransform:"uppercase", color:C.gold, marginBottom:6 }}>À bord du train</div>
          <div style={{ fontFamily:"'Fraunces',serif", fontSize: isSmall ? 24 : isMobile ? 28 : 34, fontWeight:500, color:C.text, lineHeight:1.2 }}>
            Choisissez votre classe de voyage
          </div>
        </div>

        {/* CLASS CARDS */}
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
          gap: isMobile ? 12 : 18,
          marginBottom: isMobile ? 32 : 52,
          animation: "fadeUp .5s ease .1s both",
        }}>
          {[
            { key:"eco", icon:"🚃", label:"Économique",     color:C.eco, bg:C.ecobd, border:"rgba(21,101,192,0.2)",  iconBg:"rgba(21,101,192,0.12)",  desc:"Confort standard avec sièges rembourrés, idéal pour les trajets réguliers." },
            { key:"pre", icon:"⭐", label:"1ère Classe",     color:C.pre, bg:C.prebg, border:"rgba(106,27,154,0.2)", iconBg:"rgba(106,27,154,0.12)", desc:"Sièges larges, plus d'espace personnel et service amélioré à bord." },
            { key:"vip", icon:"👑", label:"VIP / Couchette", color:C.vip, bg:C.vipbg, border:"rgba(146,64,14,0.2)",  iconBg:"rgba(146,64,14,0.12)",  desc:"Compartiments et couchettes privés pour les grands voyages de nuit." },
          ].map(cls => (
            <div key={cls.key} className="class-card" style={{
              background: cls.bg || "#fff",
              border: `1.5px solid ${cls.border}`,
              borderRadius: 18,
              padding: isMobile ? "18px 20px" : "28px 22px",
              textAlign: isMobile ? "left" : "center",
              display: isMobile ? "flex" : "block",
              alignItems: "center",
              gap: isMobile ? 16 : 0,
            }}>
              <div style={{ width: isMobile ? 48 : 58, height: isMobile ? 48 : 58, borderRadius:16, background:cls.iconBg, display:"flex", alignItems:"center", justifyContent:"center", fontSize: isMobile ? 22 : 26, margin: isMobile ? 0 : "0 auto 14px", flexShrink:0 }}>
                {cls.icon}
              </div>
              <div>
                <div style={{ fontWeight:700, fontSize:15, color:cls.color, marginBottom: isMobile ? 4 : 8 }}>{cls.label}</div>
                <div style={{ fontSize:12.5, color:C.sub, lineHeight:1.6 }}>{cls.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* SECTION TITLE */}
        <div style={{ fontSize:20, fontWeight:700, color:C.text, marginBottom:16, fontFamily:"'Fraunces',serif" }}>Tarifs par trajet</div>

        {/* DESKTOP TABLE */}
        {!isMobile && (
          <div style={{ background:C.white, borderRadius:18, overflow:"hidden", border:`1px solid ${C.border}`, boxShadow:"0 4px 32px rgba(0,0,0,0.05)", marginBottom:28, animation:"fadeUp .5s ease .2s both" }}>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead>
                <tr style={{ background:C.greenLt }}>
                  <th style={thStyle}>Trajet</th>
                  <th style={{ ...thStyle, color:C.eco }}>🚃 Économique</th>
                  <th style={{ ...thStyle, color:C.pre }}>⭐ 1ère Classe</th>
                  <th style={{ ...thStyle, color:C.vip }}>👑 VIP / Couchette</th>
                </tr>
              </thead>
              <tbody>
                {TARIFS.map((t, i) => (
                  <tr key={i} className="route-row" style={{ borderTop:`1px solid ${C.border}` }}>
                    <td style={{ ...tdStyle, fontWeight:600, color:C.text }}>
                      {t.from} <span style={{ color:C.sub, fontWeight:300 }}>→</span> {t.to}
                    </td>
                    <td style={{ ...tdStyle, fontWeight:700, color:C.eco }}>{fmt(t.eco)}</td>
                    <td style={{ ...tdStyle, fontWeight:700, color:C.pre }}>{fmt(t.pre)}</td>
                    <td style={{ ...tdStyle, fontWeight: t.vip ? 700 : 400, color: t.vip ? C.vip : "#ccc" }}>{fmt(t.vip)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* MOBILE CARDS */}
        {isMobile && (
          <div style={{ marginBottom:28 }}>
            {TARIFS.map((t, i) => (
              <div key={i} style={{ background:C.white, border:`1px solid ${C.border}`, borderRadius:16, padding:20, marginBottom:14, boxShadow:"0 2px 16px rgba(0,0,0,0.04)", animation:`fadeUp .4s ease ${i * 0.05}s both` }}>
                <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14, display:"flex", alignItems:"center", gap:6 }}>
                  {t.from} <span style={{ color:C.sub, fontWeight:300 }}>→</span> {t.to}
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
                  <FareChip label="Éco"  amount={t.eco}  color={C.eco} bg={C.ecobd || "#EBF2FF"} />
                  <FareChip label="1ère" amount={t.pre}  color={C.pre} bg={C.prebg} />
                  <FareChip label="VIP"  amount={t.vip}  color={C.vip} bg={C.vipbg} isNull={!t.vip} />
                </div>
              </div>
            ))}
          </div>
        )}

        {/* NOTE */}
        <div style={{ background:C.greenLt, border:`1px solid rgba(0,107,60,0.18)`, borderRadius:14, padding:"18px 22px", marginBottom:64, fontSize:13, color:"#445", lineHeight:1.6, display:"flex", gap:10, alignItems:"flex-start", animation:"fadeUp .5s ease .25s both" }}>
          <span style={{ fontSize:18, flexShrink:0, marginTop:1 }}>📌</span>
          <div>
            <strong>Note :</strong> Ces tarifs sont indicatifs. Les prix définitifs sont affichés lors de la réservation en gare ou en ligne. Des promotions peuvent être disponibles selon les périodes et les destinations.
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <footer style={{ background:C.green, color:"rgba(255,255,255,0.6)", textAlign:"center", padding:24, fontSize:12.5 }}>
        © 2024 <strong style={{ color:"rgba(255,255,255,0.9)" }}>SETRAG</strong> - Société d'Exploitation du Transgabonais · Tous droits réservés
      </footer>
    </>
  );
}

function FareChip({ label, amount, color, bg, isNull }) {
  return (
    <div style={{ background: isNull ? "#F5F5F5" : bg, borderRadius:10, padding:"10px 8px", textAlign:"center" }}>
      <div style={{ fontSize:10, fontWeight:700, letterSpacing:"0.8px", textTransform:"uppercase", color: isNull ? "#bbb" : color, opacity: isNull ? 1 : 0.7, marginBottom:5 }}>{label}</div>
      {isNull ? (
        <div style={{ fontSize:13, fontWeight:700, color:"#ccc" }}>-</div>
      ) : (
        <div style={{ fontSize:12, fontWeight:700, color, lineHeight:1.4 }}>
          {amount.toLocaleString("fr-FR")}<br/><small style={{ fontWeight:400, fontSize:10 }}>FCFA</small>
        </div>
      )}
    </div>
  );
}

const thStyle = {
  padding: "14px 18px",
  textAlign: "left",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "1.2px",
  textTransform: "uppercase",
  color: "#6B6B6B",
};

const tdStyle = {
  padding: "14px 18px",
  fontSize: 13.5,
  transition: "background .15s",
};